// frontend/src/services/feeConfig.ts

import api from './api';

export interface FeeConfig {
  type: 'percentage' | 'fixed' | 'combined';
  percentage_rate?: number;
  fixed_amount?: number;
  min_fee?: number;
  max_fee?: number;
  cap?: number;
}

export interface PaymentMethodFeeConfig {
  payment_method_type: string;
  fee_config: FeeConfig;
}

export interface MerchantFeeConfig {
  default_fee: FeeConfig;
  payment_method_fees?: PaymentMethodFeeConfig[];
  custom_fee_enabled: boolean;
  pass_fee_to_customer?: boolean;
}

export interface FeeBreakdown {
  amount: number;
  fee: number;
  net_amount: number;
  currency: string;
  fee_type: string;
  percentage_rate?: number;
  fixed_amount?: number;
  payment_method_type: string;
}

export interface FeePreviewRequest {
  amount: number;
  currency: string;
  payment_method_type?: string;
}

// Merchant APIs
export const getFeeConfig = async () => {
  const response = await api.get('/merchant/payments/fee-config');
  return response.data;
};

export const calculateFeePreview = async (data: FeePreviewRequest) => {
  const response = await api.post('/merchant/payments/fee-config/preview', data);
  return response.data;
};

// Admin APIs - Group Fee Config
export const adminGetGroupFeeConfig = async (groupId: string) => {
  const response = await api.get(`/admin/groups/${groupId}/fee-config`);
  return response.data;
};

export const adminUpdateGroupFeeConfig = async (groupId: string, config: MerchantFeeConfig) => {
  const response = await api.put(`/admin/groups/${groupId}/fee-config`, config);
  return response.data;
};

// Admin APIs - Merchant Fee Config (view only, returns group's config)
export const adminGetMerchantFeeConfig = async (merchantId: string) => {
  const response = await api.get(`/admin/merchants/${merchantId}/fee-config`);
  return response.data;
};
